import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../../Components/Layout/Header.jsx'
import { ObavijestiCasino } from '../../../Components/Layout/ObavijestiCasino.jsx'
import { MetaTags } from '../../../Components/Layout/MetaTags.jsx'



export class ZastitaPrivatnosti extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            textHTML: null,
            loading: true
        }
    }

    componentDidMount() {
        casino.repos.casinoDocumentsRepo.get('opcapravila/zastita_privatnosti.html').then((dataHTML) => {
            this.setState({
                loading: false,
                textHTML: dataHTML
            });
        });
    }

    render() {
        return <div>
            <MetaTags title="Pravila - Odgovorno igranje - SuperSport CASINO" description="Osvoji Jackpot! CASINO SuperSport. Veliki dobitak te čeka! Roulette, Slots, Poker, Blackjack! Zaigraj i pokaži tko je pobjednik! Najveći online casino." />
            <Header key="header" {...this.state} {...this.props}></Header>

            <div id="page-wrapper" className="white padding-2p-on-mobile border-on-tablet margin-1p-on-tablet">
                <div className="padding-sides-medium margin-center">
                    <div className="pravila-text-container">
                        {this.state.loading && <p>Učitavam sadržaj...</p>}
                        {!this.state.loading && this.state.textHTML && <div dangerouslySetInnerHTML={{ __html: this.state.textHTML }} />}
                    </div>
                </div>

            </div>

            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>


    }
};
